// TODO: create ErrorSchemas that can be imported here
// type LiteralKeys<T> = Required<T>[keyof T]

const strings = {
	title: "My Learning Designs",
	addBoard: "Add a new board",
	addCourse: "Add a new course",
	confirmRmShare: (title: string, type: "board" | "course") =>
		`Are you sure you want to remove the shared ${type == "board" ? "Session" : "Course"} '${title}' from your list?`,
	courses: "Courses",
	enter: "Enter",
	enterBoard: "Enter Session",
	enterCourse: "Enter Course",
	folaBoards: "Sessions",
	mostRecent: "Most recent",
	sharedWithMe: "Shared with me",
	showAll: "Show all",
}
export default strings
export type PersonalDashboardL10nStrings = typeof strings
